export const SUBMIT_REPORT_REQUEST = 'submitReport/SUBMIT_REQUEST';
export const SUBMIT_REPORT_SUCCESS = 'submitReport/SUBMIT_SUCCESS';
export const SUBMIT_REPORT_FAILURE = 'submitReport/SUBMIT_FAILURE';
